const DmsRoles = {
    namespaced: true,
    state: {
        tab: 0,
        dms_role: {
            id: null,
            name: null,
            description: null,
            group: null,
            active: true,
            readonly: false,
            reset_password: false,
            acl_routes: [],
        },
        errorMessages: {
            dms_role: {
                name: [],
                description: [],
                group: [],
                active: [],
                readonly: [],
                reset_password: [],
            },
        },
        permissionsOptions: [],
    },
    mutations: {
        SET_TAB(state, data) {
            state.tab = data;
        },
        SET_DMS_ROLE_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            // if (data.property === 'dms_user.pharmacy_group_id') {
            //     this.dispatch('dms_users/loadPermissionsOptions');
            // }
            // state.patient[data.property] = data.value;
        },
        SET_PERMISSIONS_OPTIONS(state, data) {
            state.permissionsOptions = data;
        },
        REMOVE_PERMISSION(state, routeId) {
            _.remove(state.dms_role.acl_routes, (permissionId) => {
                return permissionId === routeId;
            });
        },
        PUSH_PERMISSION(state, routeId) {
            state.dms_role.acl_routes.push(routeId);
        },
        SET_DMS_ROLE(state, data) {
            state.dms_role = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // _.set(state, data.property, data.value);
        },
    },
    actions: {
        changeTab({ commit }, tabIndex) {
            commit('SET_TAB', tabIndex);
        },
        updateProperty({ commit }, data) {
            commit('SET_DMS_ROLE_PROPERTY', data);
        },
        loadPermissionsOptions({ commit }) {
            axios
                .get(route('api.v1.acl-routes.grouped'), {
                    params: {
                        allowed_for_guests: 0,
                        allowed_for_all: 0,
                        limit: -1,
                    },
                })
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PERMISSIONS_OPTIONS', data);
                });
        },
        loadDmsRole({ commit }, data) {
            commit('SET_DMS_ROLE', data);
        },
        changePermissions({ commit }, { all, routeId }) {
            if (all.includes(routeId)) {
                commit('REMOVE_PERMISSION', routeId);
            } else {
                commit('PUSH_PERMISSION', routeId);
            }
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.dms_role, fieldErrors.field);
                if (fieldErrors.field && errorMessageField !== undefined) {
                    let mappedErrors;
                    if (fieldErrors.field === 'name') {
                        mappedErrors = fieldErrors.errors.map((x) =>
                            x.replaceAll(fieldErrors.field, t('roles::label.name'))
                        );
                    }
                    commit('SET_ERROR_MESSAGE', {
                        value: mappedErrors || fieldErrors.errors,
                        property: 'dms_role.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};

export default DmsRoles;
